import EventEmitter from 'events';

class Hooks extends EventEmitter {
}

const hooks = new Hooks();
// @ts-ignore
window.api = hooks;

export default hooks;
